import { render, staticRenderFns } from "./Nominate.vue?vue&type=template&id=2c5bb6e6&scoped=true"
import script from "./Nominate.vue?vue&type=script&lang=js"
export * from "./Nominate.vue?vue&type=script&lang=js"
import style0 from "./Nominate.vue?vue&type=style&index=0&id=2c5bb6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5bb6e6",
  null
  
)

export default component.exports